export const METHOD_2FA_SMS = 'SMS';
export const METHOD_2FA_GRID = 'GRID';
